import styled from 'styled-components'
import { useEffect } from 'react'

const Loading = () => {
  document.body.style.overflow = 'hidden'
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    <RouterLoaderLoadingWrap>
      <Spinner $color={`var(--white)`} />
    </RouterLoaderLoadingWrap>
  )
}

const RouterLoaderLoadingWrap = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 9998;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.7);
  justify-content: center;
  align-items: center;
`

export const Spinner = styled.div<{ $color?: string; $margin?: string }>`
  display: flex;
  margin: ${(props) => props.$margin ?? '0 auto'};
  width: 48px;
  height: 48px;
  border-radius: 50%;
  position: relative;
  animation: rotate 1s linear infinite;

  &:before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 5px solid ${(props) => props.$color ?? 'var(--black-10)'};
    animation: prixClipFix 2s linear infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes prixClipFix {
    0% {
      clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    }
    25% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    }
    50% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
    }
    75% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
    }
    100% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
    }
  }
`

export default Loading
